<template>
  <div class="absolute inset-0 backdrop-blur-sm">
    <!-- Overlay. -->
    <div class="absolute inset-0 bg-gray-700 opacity-75"></div>

    <!-- Content. -->
    <div class="absolute bottom-0 inset-x-0 inset-0 m-2 mb-8 md:m-8 p-0 flex items-center justify-center max-h-screen">
      <on-click-outside :do="close">
        <on-keydown :condition="key => key === 'Escape'" :do="close">
          <div class="bg-white rounded-lg shadow-xl m-2 md:m-8 relative flex max-h-full" role="dialog" :class="large?'w-full h-full':''" aria-modal="true" aria-labelledby="modal-headline">
            <div class="flex flex-1 flex-col space-y-0 space-x-4 max-h-full max-w-full">
              <slot name="icon"></slot>
              <div class="flex-1 flex flex-col max-h-full">
                  <slot name="header">
                    <div class="p-3 border-b-1 border-b-gray-500 items-center flex flex-row justify-between gap-4">
                      <button @click.prevent="close" class="sm:hidden mb-2 p-2 border border-gray-300 bg-white hover:bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-gray-400 h-5 w-5"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg></button>
                      <h3
                        v-if="title"
                        class="text-lg leading-6 font-medium text-gray-900 sm:mb-0 mb-4"
                        id="modal-headline"
                        v-text="title"
                      ></h3>
                      <div>
                        <div class="flex-col sm:flex-row flex items-center gap-4 actions-container">
                          <slot name="actions"></slot>
                          <button @click.prevent="close" class="hidden sm:block p-2 border border-gray-300 bg-white hover:bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-gray-400 h-5 w-5"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg></button>
                        </div>
                      </div>
                    </div>
                  </slot>
                <slot class="flex flex-1 flex-col max-h-full"></slot>
              </div>
            </div>
          </div>
        </on-keydown>
      </on-click-outside>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    large: Boolean,
    noCancel: Boolean,
    close: Function,
    closeButton: {
      type: String,
      default: 'Cancel',
    }
  },

  computed: {
    modalSize () {
      if (this.large) return 'max-w-2xl'
      return 'max-w-md'
    },
  },
}
</script>
